
import { initializeApp } from 'firebase/app';
import { getAuth, GoogleAuthProvider, signInWithPopup, signOut } from 'firebase/auth';
import { getFirestore } from 'firebase/firestore';

const firebaseConfig = {
  apiKey: "AIzaSyDbItxnI1hFyXPX2RJIJk4oB1332MU4_-k",
  authDomain: "app.pageflo.hu",
  databaseURL: "https://enji-17b86-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "enji-17b86",
  storageBucket: "enji-17b86.firebasestorage.app",
  messagingSenderId: "599123788327",
  appId: "1:599123788327:web:03b2cb6a35340b88318402",
  measurementId: "G-89HT0ZDP5K"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
auth.settings.appVerificationDisabledForTesting = true; // Enable testing mode

const provider = new GoogleAuthProvider();
provider.setCustomParameters({
  prompt: 'select_account'
});

export const db = getFirestore(app);

export const signInWithGoogle = async () => {
  try {
    const result = await signInWithPopup(auth, provider);
    return result.user;
  } catch (error) {
    console.error('Error signing in with Google:', error);
    throw error;
  }
};

export const signOutUser = () => signOut(auth);
